import { useAuthStore } from '@/auth/authStore';
import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

const BASE = SERVER_URL;

export interface DailyAdStatus {
  available: boolean;
  gems: number;
  coins: number;
}
export interface DailyAdClaim {
  gems: number;
  coins: number;
  balanceGems: number;
  balanceCoins: number;
}

async function req<T>(method: string, path: string): Promise<T> {
  const token = useAuthStore.getState().token;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...COMMON_HEADERS,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: 'include',
  });
  if (!res.ok) {
    let code = `HTTP_${res.status}`;
    try { const j = await res.json(); code = j?.error ?? code; } catch { /* */ }
    throw new Error(code);
  }
  return (await res.json()) as T;
}

export const dailyApi = {
  status: () => req<DailyAdStatus>('GET', '/me/daily-ad'),
  claim: () => req<DailyAdClaim>('POST', '/me/daily-ad'),
};
